/*
KITS_GENRE is a list of all the genres that are available in the kits:
*/
export const KITS_GENRE = {
  Acoustic: 'Acoustic',
  Alternative: 'Alternative',
  Ambient: 'Ambient',
  Blues: 'Blues',
  Classical: 'Classical',
  Country: 'Country',
  Dancehall: 'Dancehall',
  'Deep House': 'Deep House',
  Disco: 'Disco',
  'Drum and Bass': 'Drum and Bass',
  Dubstep: 'Dubstep',
  Eastern: 'Eastern',
  EDM: 'EDM',
  Electronic: 'Electronic',
  Experimental: 'Experimental',
  Folk: 'Folk',
  Funk: 'Funk',
  'Hip Hop/Rap': 'Hip Hop/Rap',
  House: 'House',
  Indie: 'Indie',
  Jazz: 'Jazz',
  Latin: 'Latin',
  'Lo-fi': 'Lo-fi',
  Metal: 'Metal',
  Pop: 'Pop',
  Punk: 'Punk',
  'R&B': 'R&B',
  Reggae: 'Reggae',
  Reggaeton: 'Reggaeton',
  Rock: 'Rock',
  Soul: 'Soul',
  Techno: 'Techno',
  Trance: 'Trance',
  Trap: 'Trap',
  'Trip Hop': 'Trip Hop'
}
